import { render, staticRenderFns } from "./GoodsClass.vue?vue&type=template&id=18d0faf6&scoped=true"
import script from "./GoodsClass.vue?vue&type=script&lang=ts"
export * from "./GoodsClass.vue?vue&type=script&lang=ts"
import style0 from "./GoodsClass.vue?vue&type=style&index=0&id=18d0faf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0faf6",
  null
  
)

export default component.exports